import React from 'react';

import { Button } from '../components/common/atom/Button';
import { Flex } from '../components/common/atom/Layout';
import { Padding, VerticalPadding } from '../components/common/atom/Padding';
import { Text } from '../components/common/atom/Text';
import { TextareaWithCounter } from '../components/common/molecules/TextareaWithCounter';
import { VerticalInputRadioList } from '../components/common/organism/InputRadioList';

import { useWithDrawal } from '../Hooks/useAuth';

const WithDrawalPage = () => {
  const {
    isLoadingWithDrawal,
    detailReason,
    reason,
    date,
    message,
    isCheckedEtc,
    doWithdrawal,
    onChange,
    onCheckReason,
  } = useWithDrawal(WITHDRAWAL_REASON);

  return (
    <Flex column alignItems="flex-start" padding="0.625rem 0 1.25rem">
      <Text weight="medium">정말 탈퇴하시겠어요?</Text>
      <Padding top={10} bottom={20}>
        <Text size={14} lineHeight={1.71}>
          탈퇴하시면 베이비페이스의 서비스를 이용할 수 없으며, 계정과 관련된
          모든 데이터가 삭제됩니다.
        </Text>
      </Padding>
      <Text weight="medium">탈퇴하려는 이유가 무엇인가요?</Text>
      <VerticalPadding padding={10}>
        <VerticalInputRadioList
          radioData={WITHDRAWAL_REASON}
          onChange={onCheckReason}
          checked={reason}
        />
      </VerticalPadding>
      <TextareaWithCounter
        maxLength={300}
        placeholder="베이비페이스를 이용하시면서 불편하셨던 점들을 알려주시면, 서비스 개선에 적극적으로 반영하겠습니다. "
        onChange={onChange}
        value={detailReason}
        name="detailReason"
        disabled={isCheckedEtc}
      />
      <Button
        size="small"
        isLoading={isLoadingWithDrawal}
        onClick={() =>
          doWithdrawal(
            <Flex column>
              <Text size={14}>{date}</Text>
              {message[200].map((idx) => (
                <Text key={idx} size={14}>
                  {idx}
                </Text>
              ))}
            </Flex>,
          )
        }
        style={{
          marginTop: '1.25rem',
          width: '50%',
          height: '1.25rem',
          alignSelf: 'center',
        }}
      >
        탈퇴하기
      </Button>
    </Flex>
  );
};

export default WithDrawalPage;

export const WITHDRAWAL_REASON = [
  {
    label: '고객 서비스(상담, 환불 등 불만)',
    value: '고객 서비스(상담, 환불 등 불만)',
  },
  {
    label: '배송 불만',
    value: '배송 불만',
  },
  {
    label: '방문 빈도가 낮음',
    value: '방문 빈도가 낮음',
  },
  {
    label: '상품 가격 불만',
    value: '상품 가격 불만',
  },
  {
    label: '상품 품질 불만',
    value: '상품 품질 불만',
  },
  {
    label: '개인 정보 유출 우려',
    value: '개인 정보 유출 우려',
  },
  {
    label: '기타 (직접 입력)',
    value: '기타 (직접 입력)',
  },
];
